<div style="display: contents" *ngIf="!selectUsuarios">
  <h1 class="textS+" style="text-align: center; height: 10%" mat-dialog-title>
    {{this.localiser.get("newProject.title")}} {{this.data.empresa.nombre}}
  </h1>

  <div mat-dialog-content class="bodyForm">
    <div class="row rowForm">
      <div class="col">
        <h4 class="textS+">{{this.localiser.get("newProject.name")}}</h4>
        <input [(ngModel)]="nombre" type="text" class="inputWidth textS" maxlength="40">
      </div>
      <div class="col">
        <h4 class="textS+">{{this.localiser.get("newProject.coordinates")}}</h4>
        <input [(ngModel)]="coordenadas" type="text" class="inputWidth textS" maxlength="50">
      </div>
    </div>
  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button (click)="newProyecto()">{{this.localiser.get("button.create")}}</button>
    </div>
  </div>

</div>

<div style="display: contents" *ngIf="selectUsuarios">
  <h1 class="textS+" style="text-align: center; height: 10%" mat-dialog-title>
    {{this.localiser.get("newProject.addUsers")}} {{data.empresa.nombre}} {{this.localiser.get("newProject.forTheProject")}}  {{proyecto.nombre}}
  </h1>

  <div mat-dialog-content class="bodyForm" *ngIf="usuarios.length > 0">
    <div *ngFor="let usuario of usuarios" style="text-align: center">
      <mat-checkbox class="textS+" (change)="change(usuario.idUsuario, $event.checked)">
        {{usuario.nombre}} {{usuario.apellidos}}
      </mat-checkbox>
    </div>
  </div>

  <div mat-dialog-content class="bodyForm" *ngIf="usuarios.length <= 0">
    <div class="middleText">
      <h3 class="textM centerVert">{{this.localiser.get("users.noUsers")}} {{data.empresa.nombre}}</h3>
    </div>
  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
  </div>

</div>

